
namespace RioERP.Reports {
    export class B2CStatewiseGstReportSummaryColumns {
        static columnsKey = 'Reports.B2CStatewiseGstReportSummary';
    }
}